export default __webpack_public_path__ + "static/media/favicon.2de9282c.ico";